import React from 'react';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const ReturnToAlertDetailsButton = (props) => {
  const getTranslation = props.getTranslation || ((value) => value);

  return (
    <Button variant="contained" color="primary" onClick={props.goBack} startIcon={<ArrowBackIcon />}>
      {getTranslation('Return To Alert Details', props.preferredLanguage)}
     </Button>
  );
};
export default ReturnToAlertDetailsButton;
